import React, { useEffect } from "react";
import "./main.css";
import "../media-queries.css";
import { isUserLoggedIn } from "../utils";
import { useNavigate } from "react-router-dom";
import { ChatPath } from "../routes";
import { LOGIN_URL, TENANT_ID } from "../utils/common";
import { getTenantBranding } from "../config/tenantBranding";
import { Logo, LogoThemes } from "@hid-galaxy-ui/galaxy-react";
import { hidLogoLarge } from "../components/Icons";

export const Login = () => {
  const navigate = useNavigate();
  const branding = getTenantBranding(TENANT_ID);

  useEffect(() => {
    if (isUserLoggedIn()) {
      navigate(ChatPath);
    }
  });
  return (
    <div className="app-container">
      <div className="hid-flex hid-full-height">
        <div className="login-wrapper">
          <div className="login__welcome">
            <div className="login__hid-logo">
              {hidLogoLarge()}
            </div>
            <h1 className="hid-typography__h1">
              {branding.welcomeTitle}
              <br />
              <span className="login__sublogo">
                {branding.welcomeSubtitle}
              </span>
            </h1>
            <h3 className="hid-typography__sublogo">
              {branding.welcomeTagline}
            </h3>
          </div>
          <div className="login__form hid-sso-login">
            <Logo
              theme={LogoThemes.Dark}
              title={branding.logoTitle}
            />
            <div
              data-testid="button-group"
              className="hid-button-group hid-button-sso-login"
            >
              <button
                type="button"
                className="hid-button hid-button--primary"
                id="sso-login"
                onClick={() => {
                  window.location.href = LOGIN_URL;
                }}
              >
                Login with SSO
              </button>
            </div>
          </div>
        </div>
        <footer className="hid-footer" data-testid="footer">
          <div className="hid-footer--base">
            <div className="hid-grid-container">
              <div className="hid-grid">
                <div className="hid-grid__column hid-grid__column--12-xs hid-grid__column--8-sm">
                  <div className="hid-flex">
                    <span>
                      © 2024 HID Global Corporation/ASSA ABLOY. All rights
                      reserved.
                    </span>
                    <ul className="hid-footer__nav">
                      <li className="hid-footer__nav-list">
                        <a
                          href="https://www.hidglobal.com/about/privacy"
                          className="hid-link"
                          target="_blank"
                        >
                          Privacy Statement
                        </a>
                      </li>
                      <li className="hid-footer__nav-list">
                        <a
                          href="https://terms-and-conditions.dev.developercommunity.hidcloud.com/HIDGlobalCorporation_TermsofUse.pdf"
                          className="hid-link"
                          target="_blank"
                        >
                          Terms of Use
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};
